import { QuizId } from '../types/quiz-interface'

export const getCourseQuizUrl = (quizId: QuizId) => `/courses/module/quiz/${quizId}`
